import { FAQItem } from '../components/FAQ/FrequentlyAskedQuestions';

const generateGoogleFrequentlyAskedQuestionsScript = (faqs: FAQItem[]) => {
  if (!faqs || faqs.length === 0) {
    return null;
  }
  const items: {
    position: number;
    name: string;
    acceptedAnswer: {
      text: string;
    };
  }[] = [];

  faqs?.forEach((faq, i) => {
    const item = {
      '@type': 'Question',
      position: i + 1,
      name: faq.name,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.acceptedAnswer,
      },
    };
    items.push(item);
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: items,
    },
  };
};

export { generateGoogleFrequentlyAskedQuestionsScript };
